
define('text!modules/strategy/templates/supplyTab.html',[],function () { return '<div class=\'w-Supply supply-tabs\'>{{>alertDialog}}</div>';});

